import * as React from "react"
import { useState, useEffect } from "react"
import Loading from '../components/Loading'
import Landing from '../components/Landing'
import anime from 'animejs'
import { Helmet } from "react-helmet"


const IndexPage = () => {
  const [welcomed, setWelcomed] = useState(false);

  useEffect(() => {
    setTimeout(()=>{
      setWelcomed(true);
    }, 3000)

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          anime({
            targets: '#' + entry.target.id,
            opacity: [0.2, 1],
            translateY: [100, 0],
            easing: 'easeInOutSine',
            duration: 2000
          })
        }
      })
    }, { threshold: 0.0 })

    let targets = ['#about', '#projects', '#skills', '#contact']

    setTimeout(() => {
      targets.forEach(target => {
        io.observe(document.querySelector(target));
      })
    }, 3000)
  }, [])

  return (
    <div>
      <Helmet>
            <meta charSet="utf-8"/>
            <meta name="description" content="My personal website hosting my portfolio and some blogs that span across Competitive Programming, Algorithms and Data Structures." />
            <meta property="og:image" content="https://jintukalita.netlify.app/frontPage.png"/>
            <meta name="keywords" content="portfolio, Jintu, Jintumoni, Kalita, Codeforces, Codechef, HackerEarth, HackerRank, Leetcode, Algorithms, Data Structures, Competitive Programming, Blogs"/>
            <meta name="theme-color" content="#1D1C29"/>
            <link rel="icon" href="/fav.png"/>
            <title>Jintu Kalita's Portfolio</title>
      </Helmet>

      {!welcomed && <Loading/> } 
      {welcomed && <Landing  setWelcomed={setWelcomed}/> }
    </div>
  )
}

export default IndexPage
